import gql from 'graphql-tag';

export class TrackingMutations {
  static trackEditorBlock = gql`
    mutation trackEditor($sections: [TrackEditorSectionArgs!], $nodes: [TrackEditorNodeArgs!]) {
      trackEditor(sections: $sections, nodes: $nodes)
    }
  `;
}
